module.exports = __webpack_public_path__ + "img/pravo_na_izobrajenie_1.f4ef2a80.png";